module.exports = __webpack_public_path__ + "static/media/image4.0e3c6135.jpg";